import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { ProvinceTable } from "@/features/province/ProvinceTable";

export function ProvinceIndex() {
  return (
    <>
      <Breadcrumbs />
      <H2>Province List</H2>
      <ProvinceTable />
    </>
  );
}
